// import areas from './areas';
import companies from './companies';
import modal from './modal';
import order from './order';
import orders from './orders';
import pois from './pois';
import newuser from './newuser';

export default {
  // areas,
  companies,
  modal,
  order,
  orders,
  pois,
  newuser,
};
